import { Component, OnInit } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { EmployeeService } from 'app/modules/shared/services/employee.service';
import {
    IGetClientSubscriptionTask,
    IGetClientSubscriptionTaskPositions,
    IGetUserSubscriptionTasks,
    SubscriptionsService,
} from 'app/modules/shared/services/subscriptions.service';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-user-subscriptions',
    templateUrl: './user-subscriptions.component.html',
    styleUrls: ['./user-subscriptions.component.scss'],
})
export class UserSubscriptionsComponent implements OnInit {
    constructor(
        private subscriptionsService: SubscriptionsService,
        private employeeService: EmployeeService
    ) {}
    gridData: GridDataResult;
    data: Array<IGetUserSubscriptionTasks | IGetClientSubscriptionTask>;
    staffPositionData: IGetClientSubscriptionTaskPositions[];
    userPosition: string;
    hasNoUserSub: boolean = false;

    ngOnInit(): void {
        this.loadData();
    }

    loadData() {
        forkJoin([
            this.subscriptionsService.getUserSubscriptionTasks(),
            this.subscriptionsService.getClientSubscriptionTaskPositions(),
            this.employeeService.getCurrentUsersEmployeeRecord(),
            this.subscriptionsService.getClientSubscriptionTask(),
        ]).subscribe(
            ([
                userSubscriptionTasksData,
                staffPositionData,
                employeeRecord,
                newClientSubscriptionTasks,
            ]) => {
                this.prepareSubscriptionData(userSubscriptionTasksData, newClientSubscriptionTasks);
                this.userPosition = employeeRecord.positionName;
                this.staffPositionData = staffPositionData;
                this.prepareGridData();
            },
            (error) => {
                console.log('error: ', error);
            }
        );
    }

    prepareSubscriptionData(userSubscriptionTasksData, newClientSubscriptionTasks) {
        const data = [];
        for (let newClientData of newClientSubscriptionTasks) {
            const associatedUserSubData = userSubscriptionTasksData.find(
                (i) => i.clientSubscriptionTaskKey == newClientData.clientSubscriptionTaskKey
            );
            if (associatedUserSubData) {
                data.push(associatedUserSubData);
            } else {
                newClientData.hasNoUserSub = true;
                data.push(newClientData);
            }
        }
        this.data = data;
    }

    prepareGridData() {
        for (let subscriptionTask of this.data) {
            const clientSubscriptionTaskKey = Number(subscriptionTask.clientSubscriptionTaskKey);

            const enabledStaffPositions = this.staffPositionData
                .filter(
                    (position) =>
                        position.clientSubscriptionTaskKey === clientSubscriptionTaskKey &&
                        position.isActive
                )
                .map((position) => position.position)
                .join(', ');
            const doesPositionMatch = this.staffPositionData.some(
                (position) =>
                    position.position === this.userPosition &&
                    position.isActive &&
                    subscriptionTask.clientSubscriptionTaskKey == position.clientSubscriptionTaskKey
            );
            subscriptionTask.enabledStaffPositions = enabledStaffPositions;
            subscriptionTask.doesPositionMatch = doesPositionMatch;
            if (subscriptionTask.hasNoUserSub) {
                subscriptionTask.enabled = true;
            }
        }

        const filteredGridData = this.data.filter((data) => data.doesPositionMatch);

        this.gridData = {
            data: filteredGridData,
            total: this.data.length,
        };
    }

    toggleTask(record) {
        const params = {
            clientSubscriptionTaskKey: record.clientSubscriptionTaskKey,
            isActive: record.enabled,
        };

        this.subscriptionsService.upsertUserSubscriptionTask(params).subscribe(
            () => {
                this.loadData();
            },
            (error) => {
                console.log('error: ', error);
            }
        );
    }
}
